<template>
  <div style="background-color: lightgray">
    <van-pull-refresh
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh">
      <van-cell center v-for="(cardItem, index) in taskList" :key="index" is-link style="line-height: 33px;"
                @click="goDetial(cardItem)"
                :value="cardItem.status == '202111300002'?cardItem.because:null">
        <template #title>
          <span class="custom-title">{{ cardItem.plateformUsername }}</span>
          <van-tag type="danger" style="margin-left: 5%;font-size: smaller">{{
              cardItem.statusStr
            }}
          </van-tag>
        </template>
        <template #icon>
          <img :src="getIcon(cardItem.plateformSerNum)" style="margin: 1%;width: 1.6rem;height: 1.6rem;"/>
        </template>
      </van-cell>
    </van-pull-refresh>
    <van-row gutter="0">
      <van-col span="24" style="text-align: center;min-height: 33px;line-height: 33px;">
        <van-button type="info" style="width: 30%;margin: 10%;" @click="addPlateformAccount">添加账号</van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import {getPlateformAccounts} from "../../api/system/sys_plateform";
import {MessageBox} from "mint-ui";

export default {
  name: "BindAccountInfos",
  data() {
    return {
      isLoading: false,
      taskList: [
        {
          accountName: "淘宝账号",
          tag: "标签",
          icon: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.jj20.com%2Fup%2Fallimg%2Ftx19%2F400320313918888.jpg&refer=http%3A%2F%2Fimg.jj20.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1634886988&t=f0a1dc517494ffe1e8b1e57430d10f72",
        },
      ],
      icons: [
        {
          id: 1,
          icon: require("../../assets/img/0.png")
        },
        {
          id: 2,
          icon: require("../../assets/img/1.png")
        },
        {
          id: 3,
          icon: require("../../assets/img/2.png")
        },
        {
          id: 4,
          icon: require("../../assets/img/3.png")
        },
        {
          id: 5,
          icon: require("../../assets/img/5.png")
        }
      ]
    }
  },
  mounted() {
    this.$emit("titleChange", "绑定账号");
  },
  computed: {
    getIcon() {
      return function (id) {
        for (let i of this.icons) {
          if (i.id == id) {
            return i.icon
          }
        }
        return null;
      }
    }
  },
  methods: {
    onRefresh() {

    },
    addPlateformAccount() {
      this.$router.push({path: '/home/addplateformaccount'});
    },
    goDetial(data){
      if (data.statusStr == "审核通过" ){
        this.$router.push({path: '/home/browseplateform', query:{id:data.id}})
      }else{
        this.$router.push({path: '/home/addplateformaccount', query:{id:data.id}});
      }
    },
    setData(data) {
      this.taskList = data;
    }
  },
  beforeRouteEnter(to, from, next) {
    getPlateformAccounts().then(res => {
      if (res.success) {
        next(vm => vm.setData(res.data));
      }
    }).catch(err => {
      MessageBox({
        title: '提示',
        message: err.message,
        showCancelButton: true
      });
    });
  }
}
</script>

<style lang="scss" scoped>

</style>
